import html2canvas from "html2canvas";


export const exportNode2PngDataURL = async (node: HTMLElement, quality: number = 0.8,scale=2): Promise<string> => {
    // create a canvas
    const canvas = await html2canvas(node, {
        allowTaint: false,
        backgroundColor: null,
        useCORS: true,
        logging: false,
        ignoreElements:(element)=>{
            return !!element.getAttribute('ignoreImageExport');
        },
        width: node.offsetWidth,
        height: node.offsetHeight,
        scale: scale,
    })

    // uncomment to show the image export from canvas
    const imageUrl = canvas.toDataURL('image/png',quality);

    return imageUrl;
}
export const exportNode2JpgDataURL = async (node: HTMLElement, quality: number = 0.8,scale=2,backgroundColor:string='black'): Promise<string> => {
  // create a canvas
  const canvas = await html2canvas(node, {
    allowTaint: false,
    backgroundColor: backgroundColor,
    useCORS: true,
    logging: false,
    ignoreElements:(element)=>{
      return !!element.getAttribute('ignoreImageExport');
    },
    width: node.offsetWidth,
    height: node.offsetHeight,
    scale: scale,
  })

  // uncomment to show the image export from canvas
  const imageUrl = canvas.toDataURL('image/jpeg',quality);

  return imageUrl;
}

export const preloadImage=(url)=> {
  const img = new Image();
  img.onerror = () => {
    console.warn('Failed to preload image:', url);
  };
  img.src = url;
}


export const IA_STYLE=[
  { label: 'Stickman', value: ':: clean line art illustration, monochrome' },
  { label: 'Line Art', value: ':: clean line art illustration, monochrome' },
  { label: 'Whiteboard', value: ':: minimalist, clean composition, negative space' },
  { label: 'Blackboard', value: ':: flat design, minimal vector illustration' },
  { label: 'Flat illustration', value: ':: flat design, minimal vector illustration' },
  { label: 'Colored 2D Flat', value: ':: flat design, minimal vector illustration' },
  { label: 'Paper cut', value: ':: flat design, minimal vector illustration' },
  { label: '3D animated', value: ':: 3D render, realistic lighting and materials' },
  { label: 'Hyper realistic', value: ':: hyperrealistic, extremely detailed photograph' },
  { label: 'Cartoon 3D', value: ':: Pixar animated movie style, soft lighting, expressive characters' },
  { label: 'Craftsman / handmade', value: ':: flat design, minimal vector illustration' },
  { label: 'LEGO', value: ':: 3D render, realistic lighting and materials' },
  { label: 'Hand-drawn Anime', value: ':: Studio Ghibli hand-drawn anime art, whimsical atmosphere' },
  { label: 'Post-Impressionist', value: ':: oil painting in the style of Vincent van Gogh' },
  { label: 'Impressionist', value: ':: impressionist painting in the style of Claude Monet' },
  { label: 'Clay / stop-motion', value: ':: 3D render, realistic lighting and materials' }
];
